import React from 'react';
import Slider from 'react-slick';

import { Settings } from 'src/types/Carousel';

export interface CarouselProps {
  settings?: Settings;
  beforeChange?: VoidFunction;
  renderSlideComponents: () => JSX.Element[];
}

const defaultSettings: Settings = {
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
};

export const Carousel = ({
  settings = defaultSettings,
  beforeChange,
  renderSlideComponents,
}: CarouselProps) => (
  <Slider {...settings} beforeChange={beforeChange}>
    {renderSlideComponents()}
  </Slider>
);
